import { DisplayMenu, MenuAndProducts } from 'common/types/entities/mongo/menu'
import { WindowProduct } from 'common/types/entities/mongo/product'
import { fetchMenusThatHasProducts } from 'common/services/finder/menu'
import { ArrayUtils } from '@shopping/common'
import { fetchProducts } from 'common/services/product'
import { ProductParam } from 'common/types/params'
import { Sort } from 'common/constants'
import { isPcEnv } from 'common/utils/common'

export interface MenuByRegion {
  selectedMenuId: string
  menuAndProductsArr: MenuAndProducts[]
  searchParam: ProductParam
}

const initialState: MenuByRegion = {
  selectedMenuId: null,
  menuAndProductsArr: [],
  searchParam: null,
}

// action types
const INIT = 'homemeal/region/INIT'
const SET_MENU = 'homemeal/region/SET_MENU'

// action creators
export const initMenuByRegion = (subVertical, regionMenuId, pageSize) => async (dispatch, getState) => {
  if (getState().menuByRegion.selectedMenuId) return

  const shuffledSubMenus: DisplayMenu[] = await fetchMenusThatHasProducts(subVertical, regionMenuId, pageSize)
    .then(menus => ArrayUtils.shuffle(menus))
    .then(shuffled => (isPcEnv ? shuffled : shuffled.slice(0, 3)))

  if (ArrayUtils.isEmpty(shuffledSubMenus)) return

  const firstMenu = ArrayUtils.getFirst(shuffledSubMenus)
  const searchParam = {
    subVertical,
    pageSize,
    page: 1,
    sort: Sort.POPULARITY,
    menuId: firstMenu.id,
  }
  const products: WindowProduct[] = await fetchProducts(searchParam).then(result => result.products)

  const menuAndProductsArr = shuffledSubMenus.map(menu => makeMenuAndProducts(menu, firstMenu.id, products))

  dispatch({ type: INIT, result: { menuAndProductsArr, searchParam, selectedMenuId: firstMenu.id } })
}

const makeMenuAndProducts = (menu: DisplayMenu, targetMenuId: string, windowProducts: WindowProduct[]) => {
  const products = menu.id === targetMenuId ? windowProducts : []
  return { menu, products }
}

export const setMenuByRegion = selectedMenuId => async (dispatch, getState) => {
  const state: MenuByRegion = getState().menuByRegion
  if (isProductFetched(state, selectedMenuId)) {
    dispatch({ type: SET_MENU, result: { ...state, selectedMenuId } })
    return
  }

  const searchParam = { ...state.searchParam, menuId: selectedMenuId }
  const products: WindowProduct[] = await fetchProducts(searchParam).then(result => result.products)

  const menuAndProductsArr = state.menuAndProductsArr.map(menuAndProducts => {
    if (menuAndProducts.menu.id !== selectedMenuId) return menuAndProducts
    return { ...menuAndProducts, products }
  })

  dispatch({ type: SET_MENU, result: { menuAndProductsArr, searchParam, selectedMenuId } })
}

const isProductFetched = (state: MenuByRegion, selectedMenuId) =>
  state.menuAndProductsArr.some(
    menuAndProducts => menuAndProducts.menu.id === selectedMenuId && ArrayUtils.isNotEmpty(menuAndProducts.products),
  )

// reducer
export default (state: MenuByRegion = initialState, action) => {
  switch (action.type) {
    case INIT:
    case SET_MENU:
      return { ...action.result }
    default:
      return state
  }
}
